import React, { forwardRef } from 'react';

import { Flex } from '@chakra-ui/react';

import { Overflow } from 'assets/assetsV1/iconComponents';

import { Button } from 'uiToolkitV1/Button';
import { Menu, MenuButton, MenuItem, MenuList } from 'uiToolkitV1/MenuV2';
import { TextBodyMedium } from 'uiToolkitV1/Typography';

const InitiativeMenuOptions = ({ menuOptions = [] }) => {
  const renderMenuItem = ({ Icon: IconComp, value, label }) => (
    <Flex alignItems="center">
      <IconComp />
      <TextBodyMedium ml={1}>{label}</TextBodyMedium>
    </Flex>
  );
  return (
    <Menu>
      <MenuButton
        as={forwardRef((props, ref) => (
          <Button ref={ref} variant="tertiary" p={0} {...props} EndIcon={() => <Overflow boxSize="24px" />} />
        ))}
      />
      <MenuList sx={{ width: '240px' }}>
        {menuOptions.map((menuItem) => (
          <MenuItem key={menuItem.value} onClick={() => menuItem.onClick()}>
            {renderMenuItem(menuItem)}
          </MenuItem>
        ))}
      </MenuList>
    </Menu>
  );
};

export default InitiativeMenuOptions;
